module.exports = __webpack_public_path__ + "img/23.6fa8f74f.png";